import { ReactNode, createContext, useEffect, useContext, useState } from "react";
import { onAuthStateChanged, User as FirebaseUser } from "firebase/auth";
import { getClientAuth } from "./firebase-client";

type AuthContextType = {
  user: FirebaseUser | null;
  loading: boolean;
};

export const AuthContext = createContext<AuthContextType>({
  user: null,
  loading: true,
});

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<FirebaseUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getClientAuth();
    console.log("Setting up auth state listener, auth:", !!auth);
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      console.log("Auth state changed:", !!user);
      setUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
